export default {
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'Linkedin',
  twitter: 'Twitter',
  youtube: 'Youtube',
  'follow-instagram': 'Follow us on Instagram',
  'share-on': 'Share on',
  flyers: 'Flyers and leaflets',
  'business-cards': 'Business cards',
  'books-magazines': 'Magazines, books & catalogues',
}
